module.exports = __webpack_public_path__ + "img/speaker-14.f3bd93bd.jpg";